import axios from 'axios'
import moment from 'moment/moment'
import React from 'react'
import {useEffect} from 'react'
import {useState} from 'react'
import Error from '../pages/Error'
import Spinner from './Spinner'

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const Messages = () => {
	const [loading, setloading] = useState(true)
	const [data, setdata] = useState([])
	const auth = window?.location?.search === '?auth=1310' ? true : false
	const Icon = (
		<svg viewBox='0 0 38 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M33.4383 8.27233L34.2083 5.74783C34.2788 5.51755 34.3938 5.30339 34.547 5.11759C34.7002 4.93178 34.8885 4.77797 35.1011 4.66493C35.3138 4.55189 35.5466 4.48183 35.7863 4.45877C36.026 4.4357 36.2679 4.46008 36.4982 4.5305C36.7285 4.60092 36.9426 4.71601 37.1284 4.8692C37.3142 5.02238 37.468 5.21067 37.5811 5.4233C37.6941 5.63593 37.7642 5.86874 37.7872 6.10845C37.8103 6.34815 37.7859 6.59005 37.7155 6.82033L35.5705 13.8328C35.4284 14.2976 35.1075 14.6868 34.6785 14.9151C34.2494 15.1434 33.7473 15.1919 33.2825 15.0502L26.27 12.9052C26.0349 12.839 25.8154 12.7265 25.6244 12.5743C25.4334 12.4221 25.2747 12.2333 25.1576 12.019C25.0406 11.8046 24.9676 11.569 24.9428 11.326C24.9181 11.083 24.9422 10.8376 25.0136 10.604C25.0851 10.3705 25.2025 10.1536 25.3589 9.96602C25.5154 9.77848 25.7077 9.62408 25.9247 9.5119C26.1416 9.39972 26.3788 9.33203 26.6223 9.31278C26.8658 9.29354 27.1106 9.32313 27.3425 9.39983L30.4078 10.3367C29.0527 8.28131 27.1626 6.63458 24.9409 5.57382C22.7193 4.51306 20.2504 4.07848 17.8001 4.31687C15.3498 4.55526 13.011 5.4576 11.0355 6.92669C9.05997 8.39579 7.52268 10.376 6.58917 12.654L6.1125 13.8145C6.02581 14.0436 5.8941 14.253 5.72513 14.4303C5.55617 14.6076 5.35339 14.7493 5.12876 14.847C4.90413 14.9446 4.66221 14.9963 4.41728 14.9989C4.17236 15.0015 3.9294 14.9549 3.70275 14.8621C3.4761 14.7692 3.27036 14.6319 3.09767 14.4582C2.92498 14.2845 2.78885 14.0779 2.69732 13.8507C2.60579 13.6235 2.56072 13.3803 2.56475 13.1354C2.56879 12.8905 2.62186 12.6489 2.72084 12.4248L3.1975 11.2643C4.38226 8.37368 6.33199 5.86031 8.83735 3.9941C11.3427 2.1279 14.3091 0.979339 17.4179 0.671753C20.5268 0.364166 23.6607 0.909169 26.4832 2.24824C29.3056 3.58732 31.7101 5.66988 33.4383 8.27233V8.27233ZM4.98134 27.7295L4.38184 30.133C4.3282 30.3714 4.22745 30.5966 4.08552 30.7955C3.94359 30.9944 3.76334 31.1629 3.55536 31.2911C3.34739 31.4193 3.11587 31.5047 2.87444 31.5422C2.633 31.5796 2.38651 31.5685 2.14944 31.5093C1.91238 31.4502 1.68953 31.3442 1.49399 31.1978C1.29845 31.0513 1.13417 30.8672 1.01079 30.6563C0.887418 30.4454 0.807443 30.2119 0.775566 29.9697C0.743689 29.7275 0.760554 29.4813 0.82517 29.2457L2.598 22.1323C2.65781 21.8901 2.76643 21.6627 2.91719 21.4639C3.06795 21.2652 3.2577 21.0993 3.4748 20.9764C3.69191 20.8535 3.93181 20.7762 4.17982 20.7493C4.42783 20.7223 4.67874 20.7463 4.91717 20.8197L11.9352 22.5687C12.4071 22.6863 12.8129 22.9866 13.0633 23.4035C13.3138 23.8204 13.3884 24.3197 13.2708 24.7916C13.1531 25.2635 12.8528 25.6693 12.4359 25.9198C12.019 26.1702 11.5197 26.2448 11.0478 26.1272L7.7735 25.3113C9.17329 27.4542 11.1519 29.1563 13.4798 30.2203C15.8078 31.2843 18.3896 31.6664 20.926 31.3225C23.4623 30.9786 25.8492 29.9227 27.8098 28.2773C29.7703 26.6318 31.2242 24.4643 32.0028 22.026C32.1507 21.5626 32.4765 21.1769 32.9087 20.9538C33.1227 20.8433 33.3563 20.7761 33.5963 20.7559C33.8363 20.7357 34.0779 20.763 34.3073 20.8362C34.5368 20.9094 34.7496 21.027 34.9335 21.1824C35.1175 21.3379 35.269 21.528 35.3795 21.742C35.49 21.956 35.5573 22.1896 35.5775 22.4296C35.5976 22.6696 35.5704 22.9112 35.4972 23.1407C34.7339 25.5349 33.4553 27.7329 31.7512 29.5798C30.0472 31.4267 27.9591 32.8778 25.6338 33.8308C22.0108 35.3151 17.99 35.5194 14.2352 34.4102C10.4804 33.3009 7.21611 30.9443 4.98134 27.7295V27.7295Z'
				fill='black'
			/>
		</svg>
	)

	const fetchmessages = () => {
		setloading(true)
		axios
			.post(`${BASE_URL}/getallmessages`, {
				auth: 'authbt-&$13102003',
			})
			.then((res) => {
				setloading(false)
				setdata(res?.data?.data)
			})
	}

	useEffect(() => {
		fetchmessages()
	}, [])

	return (
		<>
			{auth ? (
				<div className='messeges'>
					<h1>
						All messeges <span>({data?.length})</span>
						<button onClick={fetchmessages} className='refresh_btn'>
							{Icon}
						</button>
					</h1>
					{loading ? (
						<Spinner />
					) : (
						data?.map((item, index) => (
							<div key={index} className='messegecard b-radius bx-s '>
								<h3>
									Name :<span> {item?.name}</span>
								</h3>
								<h3>
									Email :<span> {item?.email}</span>
								</h3>
								<h4>
									Date :
									<span>
										{moment(item?.postedOn * 1).format('LLL')} -
										{moment(item?.postedOn * 1).fromNow()}
									</span>
								</h4>
								<p>
									Message :<span> {item?.message}</span>
								</p>

								<button
									onClick={() => {
										axios.post(`${BASE_URL}/deletemessage?id=${item?._id}`)
										fetchmessages()
									}}>
									<img data-invertable src='/icons/delete.svg' alt='' />
								</button>
							</div>
						))
					)}
				</div>
			) : (
				<Error />
			)}
		</>
	)
}

export default Messages
